import { descriptors } from '../../constants';

export default (subscriptionDescriptors = [], freeTrialDescriptor = descriptors.freeTrial) =>
  subscriptionDescriptors.includes(freeTrialDescriptor);
